<template>
  <ul class="ui-breadcrumb">
    <li class="breadcrumb-item">当前位置：</li>
    <li v-for="(item, index) in items" :key="index" class="breadcrumb-item">
      <span v-if="(index + 1) < items.length" class="text" @click.prevent="navigateTo(item)">
        {{ item.text || item }}
      </span>
      <span v-else class="text">{{ item.text || item }}</span>
      <span v-if="(index + 1) < items.length" class="breadcrumb-item divider">{{ $props.divider }}</span>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    divider: {
      type: String,
      default: '>',
    },
  },
  methods: {
    navigateTo({ to }) {
      if (to) {
        this.$router.push(to);
      }
    },
  },
};
</script>

<style scoped>
.ui-breadcrumb {
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 20px;
  border-bottom: #035fcf solid 1.5px;
}
.breadcrumb-item {
  display: inline-block;
  cursor: pointer;
}

.breadcrumb-item:last-child {
  opacity: 0.5;
}

.breadcrumb-item .divider {
  padding: 0 5px;
}
</style>